'use client'

import { sendReferralTracker } from '@/actions/authentication';
import useAppStore from '@/core/stores/app';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { ReferralType } from '@/types/partnership';
import { useEffect } from 'react';


export default function HandleReferralCode() {
    const baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_URL!
    const { params: { referralCode } } = useSetSearchParams()
    const handleSendReferralTracker = async (type: ReferralType = ReferralType.Visit) => {
        const res = await sendReferralTracker(referralCode!, baseUrl, type)
    }
    const { setReferralCode } = useAppStore()
    useEffect(() => {
        if (referralCode) {
            handleSendReferralTracker()
            setReferralCode(referralCode)
        }
    }, [referralCode])

    return null;
}